module.exports = __webpack_public_path__ + "static/media/gonerdify.net_Presentation_help.37253766.png";